import React from "react";
import { FormLabel, Box, Tooltip } from "@chakra-ui/react";
import { Icon } from "@familyzone/component-library";

type ConfigFormLabelProps = {
  label?: string;
  tooltip?: string;
  containerRef?: React.RefObject<HTMLElement>;
};

export const ConfigFormLabel = ({ label, tooltip, containerRef }: ConfigFormLabelProps): JSX.Element => (
  <Box
    sx={{
      display: "flex",
      gap: "4px",
      alignItems: "center",
    }}
  >
    <FormLabel>{label}</FormLabel>
    {tooltip && (
      <Tooltip portalProps={{ containerRef }} hasArrow placement={"right"} variant={"dark"} label={tooltip} sx={{ maxWidth: "500px" }}>
        <Box display={"flex"} alignItems={"center"}>
          <Icon boxSize={"3"} color={"grey"} aria-label={"circle-question-icon"} icon="fa-circle-question" />
        </Box>
      </Tooltip>
    )}
  </Box>
);
